import Navigation from "./src/navigation";
import {useFonts} from "expo-font";
import configureStore from "./src/redux/store/store";
import {Provider} from "react-redux";

export default function App() {

    const store = configureStore();
    let appID = document.getElementById('root').getAttribute('data-appid')
    if(!appID) {
        appID = '4526'
    }

    const [fontsLoaded] = useFonts({
        'Raleway':require('./src/assets/fonts/Raleway-Medium.ttf')
    });

    if (!fontsLoaded) {
        return null;
    }

  return (
      <Provider store={store}>
          <Navigation appID={appID} />
      </Provider>
  )
}